class MapComponent extends HTMLElement {
    constructor() {
        super();
        this.map;

        this.mapStyle = [
            {
                elementType: "geometry",
                stylers: [
                    {
                        color: "#000000",
                    },
                ],
            },
            {
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#757575",
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#212121",
                    },
                ],
            },
            {
                featureType: "administrative",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#111316",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "administrative.country",
                stylers: [
                    {
                        color: "#111316",
                    },
                    {
                        weight: 1,
                    },
                ],
            },
            {
                featureType: "administrative.country",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#bdbdbd",
                    },
                ],
            },
            {
                featureType: "administrative.land_parcel",
                stylers: [
                    {
                        color: "#111316",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "administrative.locality",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#bdbdbd",
                    },
                ],
            },
            {
                featureType: "administrative.province",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#414242",
                    },
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "landscape",
                stylers: [
                    {
                        color: "#111316",
                    },
                ],
            },
            {
                featureType: "landscape.man_made",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#a6a6a6",
                    },
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "poi",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#bdbdbd",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#181818",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#616161",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1b1b1b",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#2d3b4f",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#8a8a8a",
                    },
                ],
            },
            {
                featureType: "road.arterial",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#252a32",
                    },
                    {
                        visibility: "simplified",
                    },
                    {
                        weight: 1.5,
                    },
                ],
            },
            {
                featureType: "road.arterial",
                elementType: "labels.text",
                stylers: [
                    {
                        color: "#252a32",
                    },
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "road.arterial",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#616161",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2d3b4f",
                    },
                    {
                        visibility: "simplified",
                    },
                    {
                        weight: 1.5,
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text",
                stylers: [
                    {
                        color: "#252a32",
                    },
                ],
            },
            {
                featureType: "road.highway.controlled_access",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2d3b4f",
                    },
                    {
                        visibility: "on",
                    },
                    {
                        weight: 1,
                    },
                ],
            },
            {
                featureType: "road.local",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#252a32",
                    },
                    {
                        visibility: "simplified",
                    },
                    {
                        weight: 1,
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels.text",
                stylers: [
                    {
                        color: "#252a32",
                    },
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#616161",
                    },
                ],
            },
            {
                featureType: "transit",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#757575",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#000000",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#3d3d3d",
                    },
                ],
            },
        ];
        this.onlyHidePointsStyle = [
            {
                featureType: "poi",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
        ];

        this.initMap();
    }

    initMap() {
        window.addEventListener("load", () => {
            let bounds = new google.maps.LatLngBounds();

            const cityListElement = document.querySelector("#CityList")
                ? JSON.parse(document.querySelector("#CityList").innerHTML)
                : null;
            const places = [];

            if (cityListElement) {
                if (window.location.pathname == "/pages/negozi") {
                    cityListElement.forEach((city) => {
                        city.stores.forEach((store) => {
                            places.push({ ...store, handle: city.handle });
                        });
                    });
                } else {
                    cityListElement.stores.forEach((store) => {
                        places.push({
                            ...store,
                            handle: cityListElement.handle,
                        });
                    });
                }
            }

            let center = new google.maps.LatLng(-34.397, 150.644);

            if (places.length > 0) {
                center = new google.maps.LatLng(
                    parseFloat(places[0].coords.lat),
                    parseFloat(places[0].coords.lng)
                );
            }

            const mapOptions = {
                zoom: 5,
                maxZoom: 17,
                center: center,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                //styles: this.mapStyle,
                styles: this.onlyHidePointsStyle,
                disableDefaultUI: true,
            };

            this.map = new google.maps.Map(
                document.querySelector("map-component"),
                mapOptions
            );

            for (const place of places) {
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(
                        parseFloat(place.coords.lat),
                        parseFloat(place.coords.lng)
                    ),
                    map: this.map,
                    //icon: "https://cdn.shopify.com/s/files/1/0783/9101/7774/files/location.svg?v=1699348658",
                    animation: google.maps.Animation.DROP,
                });

                if (window.location.pathname == "/pages/negozi") {
                    marker.addListener("click", () => {
                        window.location.href = `/pages/negozi-${place.handle}`;
                    });
                }

                marker.setMap(this.map);
                bounds.extend(marker.getPosition());
                console.log(bounds, this.map);
            }

            this.map.fitBounds(bounds);

            google.maps.event.addListenerOnce(
                this.map,
                "bounds_changed",
                function () {
                    console.log(this.map);
                    var desiredZoom = 14;
                    if (this.map?.getZoom() > desiredZoom) {
                        this.map.setZoom(desiredZoom);
                    }
                }
            );
        });
    }
}

customElements.define("map-component", MapComponent);
